import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Card } from '@/components/ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { Monitor, Smartphone, Tablet } from 'lucide-react';
import { DispositivoData } from '../utils/mockData';

interface ChartDispositivosProps {
  data: DispositivoData[];
}

export function ChartDispositivos({ data }: ChartDispositivosProps) {
  useLanguage();
  const chartData = data.map(d => ({ 
    name: d.tipo === 'desktop' ? 'Desktop' : d.tipo === 'mobile' ? 'Mobile' : 'Tablet',
    value: d.valor 
  }));
  
  const COLORS = {
    desktop: '#2F6FED',
    mobile: '#8B5CF6',
    tablet: '#F59E0B'
  };
  
  const ICONS = {
    desktop: Monitor,
    mobile: Smartphone,
    tablet: Tablet
  };
  
  return (
    <Card className="border border-[#E5E7EB] rounded-[14px] p-6">
      <div className="mb-4">
        <h3 className="text-[15px] font-semibold text-[#101828]">{translateInterfaceText("Dispositivos")}</h3>
        <p className="text-[12px] text-[#667085] mt-1">{translateInterfaceText("Distribuição por tipo de dispositivo")}</p>
      </div>
      
      <div className="flex items-center gap-6">
        {/* Gráfico Donut */}
        <div className="w-40 h-40">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={70}
                paddingAngle={2}
                dataKey="value"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[entry.tipo]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: '#FFFFFF',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '12px'
                }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        {/* Lista com ícones */}
        <div className="flex-1 space-y-4">
          {data.map((dispositivo, index) => {
            const Icon = ICONS[dispositivo.tipo];
            const color = COLORS[dispositivo.tipo];
            const name = dispositivo.tipo === 'desktop' ? 'Desktop' : 
                        dispositivo.tipo === 'mobile' ? 'Mobile' : 'Tablet';
            
            return (
              <div key={index} className="flex items-center gap-3">
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center shrink-0"
                  style={{ backgroundColor: `${color}15` }}
                >
                  <Icon className="w-6 h-6" style={{ color }} />
                </div>
                <div className="flex-1">
                  <div className="text-[13px] font-medium text-[#101828]">{name}</div>
                  <div className="text-[11px] text-[#667085]">
                    {dispositivo.valor} {" "}{translateInterfaceText("leads (")}{dispositivo.porcentagem}%)
                  </div>
                </div>
                <div className="text-[20px] font-bold text-[#101828]">
                  {dispositivo.porcentagem}%
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Card>
  );
}
